import script from "./MembersRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./MembersRoute.vue?vue&type=script&setup=true&lang=js"

import "./MembersRoute.vue?vue&type=style&index=0&id=6d411f64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d411f64"]])

export default __exports__